import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import {
  fetchAllowedMenus,
  GetUserTasks,
  fetchUserEditData,
  UserTaskList,
  userTypeItem,
} from "../Services/APIService";
import { useNavigate } from "react-router-dom";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import { useLocation } from "react-router-dom";

interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList?: [];
}

const UserTask: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [usersTask, setusersTask] = useState<UserTaskList[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [searchText, setSearchText] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, []);

  useEffect(() => {
    const fetchUsers = async (): Promise<void> => {
      try {
        const usersTaskData = await GetUserTasks();
        setusersTask(usersTaskData);
        setLoading(false);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleEdit = async (taskId: number) => {
    try {
      const response = await GetUserTasks();
      const matchedTask = response.find((task) => task.id === taskId);
      navigate("/editUserTask", {
        state: { taskData: matchedTask },
      });
    } catch (error) {
      console.error("Error fetching user edit data:", error);
      alert("Failed to fetch user data for editing");
    }
  };

  // Filter users based on search input
  const filteredUsers = usersTask.filter(
    (usertask) =>
      usertask.followupTypeId
        .toString()
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      usertask.leadId
        .toString()
        .toLowerCase()
        .includes(searchText.toLowerCase())
  );

  // Columns including SL No
  const columns = [
    {
      name: "Sl No",
      cell: (_row: UserTaskList, index: number) => index + 1,
      width: "80px",
    },
    {
      name: "Lead Name",
      selector: (row: UserTaskList) => row.leadId,
      sortable: true,
    },
    {
      name: "Project Name",
      selector: (row: UserTaskList) => row.projectId,
      sortable: true,
    },
    {
      name: "Assigned User",
      selector: (row: UserTaskList) => row.assignedUser,
      sortable: true,
    },
    {
      name: "Followup Type",
      selector: (row: UserTaskList) => row.followupTypeId,
      sortable: true,
    },
    //{ name: "Alt. Phone", selector: (row: User) => row.alternativePhone },
    //{ name: "Reports To", selector: (row: User) => row.reportToUserName },
    {
      name: "Followup Date",
      selector: (row: UserTaskList) => {
        if (!row.followupDate) return "";

        const date = new Date(row.followupDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");

        return `${day}-${month}-${year} ${hours}:${minutes}`;
      },
    },
    {
      name: "Actions",
      cell: (row: UserTaskList) => (
        <i
          className="bi bi-pencil-square colorgreen"
          style={{ cursor: "pointer" }}
          onClick={() => handleEdit(row.id)}
        ></i>
      ),
    },
  ];

  if (loading) {
    return <div className="p-4 text-center">Loading users data...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="wrapper">
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <div className="card-header carHeaderWithBtn">
                      <div className="card-title mb-0">Task List</div>
                      <div>
                        {" "}
                        <input
                          type="text"
                          placeholder="Search by Name, Email, or Mobile"
                          className="p-2 w-full datatableSearchInput"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => navigate("/createUser")}
                        >
                          + Add User
                        </button>
                      </div>
                    </div>
                    <div className="card-body pt-0">
                      <DataTable
                        columns={columns}
                        data={filteredUsers}
                        pagination
                        paginationPerPage={10}
                        highlightOnHover
                        striped
                        responsive
                        noDataComponent="No users found"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default UserTask;
